import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'semantic-ui-react';
import cm from 'helpers/commons';
import styled from 'styled-components';

const propTypes = {
  items: PropTypes.object,
  salesSum: PropTypes.number,
  companySum: PropTypes.number
};

const defaultProps = {
  items: null,
  salesSum: null,
  companySum: null
};

class BillItems extends Component {
  billDetSel = () => {
    const { billDetListSel, billDetTotalSel, invoiceIdx, onOpenModal } = this.props;
    const params = {
      page: 1,
      pageRow: 15
    };
    try {
      onOpenModal('BILL_DET'); //팝업 오흔
      billDetTotalSel(invoiceIdx); //식대 상세 total 조회
      billDetListSel(invoiceIdx, params); // 식대 상세 조회
    } catch (error) {
      console.log('##### error: ', error);
    }
  };

  render() {
    const { items, salesSum, companySum, isButtonView } = this.props;
    let totalSum = {
      salesSum: 0,
      companySum: 0
    };
    let unit = cm.unit();
    return (
      <div className="table-box">
        {items ? (
          <Table celled>
            <StyledHeader>
              <Table.Row>
                <StyledHeaderCell style={{ width: 160 }}>합계</StyledHeaderCell>
                <StyledHeaderCell colSpan="2">{cm.numberComma(companySum)}원</StyledHeaderCell>
              </Table.Row>
            </StyledHeader>
            <Table.Body>
              <Table.Row>
                <Table.Cell style={{ fontWeight: 'bold' }}>회사식대 총액</Table.Cell>
                <Table.Cell>
                  {unit === '원'
                    ? `${cm.numberComma(companySum)}원`
                    : `${cm.numberComma(salesSum)}장(${cm.numberComma(companySum)}원)`}
                </Table.Cell>
                <StyledCellButton textAlign="center">
                  {isButtonView ? (
                    <StyledButton color="black" inverted content="식대 상세내역" onClick={this.billDetSel} />
                  ) : null}
                </StyledCellButton>
              </Table.Row>
            </Table.Body>
          </Table>
        ) : null}
      </div>
    );
  }
}

BillItems.propTypes = propTypes;
BillItems.defaultProps = defaultProps;

const StyledHeader = styled(Table.Header)`
  &&&& {
    background-color: #243346;
    color: #ffffff;
  }
`;

const StyledHeaderCell = styled(Table.HeaderCell)`
  &&&& {
    background-color: #243346;
    border-left-color: #dcdcdc;
    color: #ffffff;
  }
`;

const StyledCellButton = styled(Table.Cell)`
  &&&& {
    width: 150px;
    border-left: 0;
  }
`;

const StyledButton = styled(Button)`
  &&&& {
    top: 55px;
    right: 15px;
  }
`;

export default BillItems;
